import { httpsCallable } from 'firebase/functions';
import { databaseId, functions } from '@/lib/firebase';

interface SendWelcomeEmailResponse {
  sent: boolean;
}

const sendWelcomeEmailFn = httpsCallable<
  { databaseId: string; targetUid?: string },
  SendWelcomeEmailResponse
>(functions, 'sendWelcomeEmail');

export const emailService = {
  async sendWelcomeEmail(targetUid?: string): Promise<void> {
    await sendWelcomeEmailFn(targetUid ? { databaseId, targetUid } : { databaseId });
  },
};
